import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import RootScreen from './ui/root-screen';
import DialogueDiagramHome from './ui/access/dialogue-diagram/dialogue-diagram-home';
import ContextDiagramHome from './ui/access/context-diagram/context-diagram-home';
import DfdDiagramHome2 from './ui/access/dfd-diagram-2/dfd-diagram-home';
import ErdDiagramHome from './ui/access/erd-diagram/erd-diagram-home';
import ClassDiagramHome from './ui/access/class-diagram/class-diagram-home';
import StateDiagramHome from './ui/access/state-diagram/state-diagram-home';
import SequenceDiagramHome from './ui/access/sequence-diagram/sequence-diagram-home';
import CollaborationDiagramHome from './ui/access/collaboration-diagram/collaboration-diagram-home';
import StructureChartHome from './ui/access/structure-chart/structure-chart-home';
import UseCaseDiagramHome from './ui/access/use-case-diagram/use-case-diagram-home';
import ActivityDiagramHome from './ui/access/activity-diagram/activity-diagram-home';
import ReportHome from './ui/access/report/report-home';
import ScreenHome from './ui/access/screen/screen-home';
import DecisionTableHome from './ui/access/decision-table/decision-table-home';
import DfdDiagramHome from './ui/access/dfd-diagram/dfd-diagram-home';
import DecisionTreeHome from './ui/data-mining/classifiers/decision-tree/decision-tree-home';
import KMeansHome from './ui/data-mining/cluster/k-means/k-means-home';
import DbScanHome from './ui/data-mining/cluster/db-scan/db-scan-home';
import SilhouetteHome from './ui/data-mining/cluster/silhouette/silhouette-home';
import HierarchyHome from './ui/data-mining/cluster/hierarchy/hierarchy-home';
import MatrixCreationHome from './ui/data-mining/cluster/matrix-creation/matrix-creation-home';
import OutputVectorHome from './ui/data-mining/network/output-vector/output-vector-home';
import BayesianNetworksHome from './ui/data-mining/bayesian-networks/bayesian-networks-home';
import AprioriHome from './ui/data-mining/association-rules/apriori/apriori-home';
import FPGrowthHome from './ui/data-mining/association-rules/fp-growth/fp-growth-home';
import NaiveBayesHome from './ui/data-mining/classifiers/naive-bayes-classifier/naive-bayes-home';
import KnnHome from './ui/data-mining/classifiers/knn-classifier/knn-home';

const OpenuSolverHome = () => {

    const { pathname } = useLocation();

    useEffect(() => {
        document.title = 'OPENU Solver | Productivity';
    }, []);

    return (
        <div className="flex flex-col flex-1 leading-7 h-screen relative z-50 bg-white w-screen">
            <div className="overflow-auto px-4 pb-10">
                <div>

                    {
                        pathname === '/openu-solver' && <RootScreen/>
                    }

                    {
                        pathname === '/openu-solver/data-mining/decision-tree' && <DecisionTreeHome/>
                    }

                    {
                        pathname === '/openu-solver/data-mining/cluster-k-means' && <KMeansHome/>
                    }

                    {
                        pathname === '/openu-solver/data-mining/cluster-db-scan' && <DbScanHome/>
                    }

                    {
                        pathname === '/openu-solver/data-mining/cluster-silhouette' && <SilhouetteHome/>
                    }

                    {
                        pathname === '/openu-solver/data-mining/cluster-hierarchy' && <HierarchyHome/>
                    }

                    {
                        pathname === '/openu-solver/data-mining/matrix-creation' && <MatrixCreationHome/>
                    }

                    {
                        pathname === '/openu-solver/data-mining/network-output-vector' && <OutputVectorHome/>
                    }

                    {
                        pathname === '/openu-solver/data-mining/bayesian-networks' && <BayesianNetworksHome/>
                    }

                    {
                        pathname === '/openu-solver/data-mining/apriori' && <AprioriHome/>
                    }

                    {
                        pathname === '/openu-solver/data-mining/fp-growth' && <FPGrowthHome/>
                    }

                    {
                        pathname === '/openu-solver/data-mining/naive-bayes' && <NaiveBayesHome/>
                    }

                    {
                        pathname === '/openu-solver/data-mining/knn' && <KnnHome/>
                    }

                    {
                        pathname === '/openu-solver/access/context-diagram' && <ContextDiagramHome/>
                    }

                    {
                        pathname === '/openu-solver/access/dfd-diagram' && <DfdDiagramHome/>
                    }

                    {
                        pathname === '/openu-solver/access/dfd-diagram-2' && <DfdDiagramHome2/>
                    }

                    {
                        pathname === '/openu-solver/access/erd-diagram' && <ErdDiagramHome/>
                    }

                    {
                        pathname === '/openu-solver/access/dialogue-diagram' && <DialogueDiagramHome/>
                    }

                    {
                        pathname === '/openu-solver/access/structure-chart' && <StructureChartHome/>
                    }

                    {
                        pathname === '/openu-solver/access/class-diagram' && <ClassDiagramHome/>
                    }

                    {
                        pathname === '/openu-solver/access/state-diagram' && <StateDiagramHome/>
                    }

                    {
                        pathname === '/openu-solver/access/sequence-diagram' && <SequenceDiagramHome/>
                    }

                    {
                        pathname === '/openu-solver/access/collaboration-diagram' && <CollaborationDiagramHome/>
                    }

                    {
                        pathname === '/openu-solver/access/use-case-diagram' && <UseCaseDiagramHome/>
                    }

                    {
                        pathname === '/openu-solver/access/activity-diagram' && <ActivityDiagramHome/>
                    }

                    {
                        pathname === '/openu-solver/access/report' && <ReportHome/>
                    }

                    {
                        pathname === '/openu-solver/access/screen' && <ScreenHome/>
                    }

                    {
                        pathname === '/openu-solver/access/decision-table' && <DecisionTableHome/>
                    }

                </div>
            </div>
        </div>
    )
};

export default OpenuSolverHome;